/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cron_Weekly_MondayInputs */

const cs_cron_weekly_monday = /** @type {(inputs: Cron_Weekly_MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Týdně v pondělí 9:00`)
};

const en_cron_weekly_monday = /** @type {(inputs: Cron_Weekly_MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekly on Monday 9:00`)
};

/**
* | output |
* | --- |
* | "Weekly on Monday 9:00" |
*
* @param {Cron_Weekly_MondayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const cron_weekly_monday = /** @type {((inputs?: Cron_Weekly_MondayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cron_Weekly_MondayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cron_weekly_monday(inputs)
	return cs_cron_weekly_monday(inputs)
});